<div class="flap-container" [class.flipping]="isFlipping()">
  <!-- Static card behind rotating flap - shows top of NEXT character -->
  <div class="flap-static-next">
    <div class="flap-char">{{ nextChar() }}</div>
  </div>

  <!-- Rotating top flap -->
  <div class="flap-rotating-top">
    <!-- Front side: top of current character -->
    <div class="flap-front">
      <div class="flap-char">{{ currentChar() }}</div>
    </div>
    <!-- Back side: bottom of next character -->
    <div class="flap-back">
      <div class="flap-char">{{ nextChar() }}</div>
    </div>
  </div>

  <!-- Static bottom half - shows bottom of CURRENT character (never moves) -->
  <div class="flap-static-bottom">
    <div class="flap-char">{{ currentChar() }}</div>
  </div>

  <!-- Center line divider -->
  <div class="flap-divider"></div>
</div>